<script>

export default {
    name: 'OrderbumpsCheckBox',
    props: ["orderBumpData", 'field', 'index'],
    mounted(){

    }
}
</script>

<template>
    <option :value="orderBumpData">{{ orderBumpData }} </option>
</template>
